import React, { useState, useEffect } from "react";
import { CommonHeader } from "../Shared/Header";
import { Outlet, NavLink } from "react-router-dom";
import { QIFlashScreen } from "../../components";
import { FMDPStorage } from "../../shared/helper";
import { useDispatch, useSelector } from "react-redux";
import { setlastVisitedApp } from "../../reduxStore/features";
import { NativeSvgIcon } from "../Admin/Shared/";
import { getLocalizedString } from "../../shared/translation";
import { useSelectClientAppMutation } from "../Authentication/service";
import "./style/index.scss";

export const DriverBehaviorLayout = () => {
  const [selectedAppId, setLayoutSelectedAppId] = useState(FMDPStorage.get("selected-app-id"));
  const [appToToggle, setAppToToggle] = useState(selectedAppId);
  const [switchClicked, setSwitchClicked] = useState(null); // Changed to store app type instead of boolean
  const dispatch = useDispatch();

  const flashScreenStatus = useSelector((state) => state.common.flash_screen);

  const currentUser = FMDPStorage?.get("current-user")?.client_apps;

  const [
    selectClientApp,
    {
      isSuccess: selectClientAppSuccess,
      data: clientAppData,
      reset: resetSelectClientApp,
      error: selectClientAppError,
    },
  ] = useSelectClientAppMutation({
    fixedCacheKey: "shared-client-app-data",
  });

  const iDforClient = currentUser?.find((user, id) => {
    return user.id === selectedAppId;
  })?.client?.id;

  const filteredClients = currentUser?.filter((user) => {
    return user?.client?.id === iDforClient;
  });

  useEffect(() => {
    if (switchClicked) {
      try {
        if (filteredClients.length > 1) {
          let targetApp = null;

          // Find the specific app based on switchClicked value
          if (switchClicked === "management") {
            targetApp = filteredClients?.find((app) => app.name?.endsWith("- Management Portal"));
          } else if (switchClicked === "tracking") {
            targetApp = filteredClients?.find((app) => app.name?.endsWith("- Tracking"));
          } else {
            // Fallback to old behavior - find first non-current app
            const toggleId = filteredClients?.filter((item) => {
              return item.id !== selectedAppId;
            });
            targetApp = toggleId[0];
          }

          if (targetApp && targetApp.id !== appToToggle) {
            setAppToToggle(targetApp.id);
            selectClientApp({ client_app_id: targetApp.id });
          }
        }
      } catch (e) {
        console.log(e);
      }
      // Reset switchClicked after processing
      setSwitchClicked(null);
    }
  }, [selectedAppId, currentUser, switchClicked, filteredClients]);

  //dispatch client
  useEffect(() => {
    if (selectedAppId) {
      dispatch(setlastVisitedApp(selectedAppId));
    }
  }, [selectedAppId, dispatch]);

  // Left panel navigation links
  const leftPanelLinks = [
    { label: getLocalizedString("dashboard", "Dashboard"), path: "dashboard", icon: "dashboard" },
    { label: getLocalizedString("areas", "Areas"), path: "areas", icon: "area" },
    { label: getLocalizedString("vendor", "Vendor"), path: "vendor", icon: "vendor" },
    { label: getLocalizedString("reports", "Reports"), path: "reports", icon: "reports" },
    // { label: getLocalizedString("setting", "Setting"), path: "setting", icon: "undefined" },
  ];

  return (
    <QIFlashScreen currentAppId={selectedAppId} flashScreenStatus={flashScreenStatus}>
      <>
        <CommonHeader
          setLayoutSelectedAppId={setLayoutSelectedAppId}
          appToToggle={appToToggle}
          appName="EcoDriveDriverScore"
        />

        <main className="driver-behavior-app-container-wrapper">
          <aside className="qi-nav-bar primary left">
            <nav className="qi-nav-bar_navigation">
              {/* Enabled MP - Only show if user has access to Management Portal app */}
              {filteredClients?.some((app) => app.name?.endsWith("- Management Portal")) && (
                <div
                  onClick={() => {
                    setSwitchClicked("management");
                  }}
                  key="management-portal"
                  className={`qi-nav-bar_navigation_item`}
                >
                  <NativeSvgIcon name={"management"} />
                  <div className="qi-nav-bar_navigation_item_info">
                    <span className="">
                      {getLocalizedString("management_portal", "Management Portal")}
                    </span>
                  </div>
                </div>
              )}

              {/* Switch to Tracking if available - Only show if user has access to Tracking app */}
              {filteredClients?.some((app) => app.name?.endsWith("- Tracking")) && (
                <div
                  onClick={() => {
                    setSwitchClicked("tracking");
                  }}
                  key="tracking"
                  className={`qi-nav-bar_navigation_item`}
                >
                  <NativeSvgIcon name={"tracking"} />
                  <div className="qi-nav-bar_navigation_item_info">
                    <span className="">{getLocalizedString("tracking", "Tracking")}</span>
                  </div>
                </div>
              )}

              {/* Active Driver Score */}
              <div
                onClick={() => {}}
                key="driver-score-active"
                className={`qi-nav-bar_navigation_item active`}
              >
                <NativeSvgIcon name={"driver-score"} />
                <div className="qi-nav-bar_navigation_item_info">
                  <span className="">{getLocalizedString("driver_score", "Driver Score")}</span>
                </div>
              </div>

              <ul className="qi-nav-bar_navigation_sub-nav">
                {leftPanelLinks.map((section, index) => (
                  <li key={`${section.path}-${index}`} className="qi-nav-bar_navigation_sub-nav_item">
                    <NavLink
                      to={`/driver-behavior/${section.path}`}
                      className={`qi-nav-bar_navigation_sub-nav_item_link visible`}
                    >
                      <NativeSvgIcon name={`${section.icon}`} />
                      <div className="qi-nav-bar_navigation_sub-nav_item_info">
                        <span className="">{section.label}</span>
                      </div>
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
            <div className="copyright">
              <span>&copy;</span>
              <p className="copyright_info">
                {getLocalizedString("copy_right", "Copyright")} &copy;
                {new Date().getFullYear()}{" "}
                {getLocalizedString(
                  "fleet_management_all_rights_reserved",
                  "Fleet Management. All rights reserved."
                )}
              </p>
            </div>
          </aside>

          <div className="driver-behavior-content">
            <Outlet />
          </div>
        </main>
      </>
    </QIFlashScreen>
  );
};
